// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"9":"11bf5313","118":"2c41b4fa"}[chunkId] + ".chunk.js");